import * as React from 'react'
import { isMoving, reduceMotion, styleForCustomLogo } from '../../utils/logo';

export interface LogoProps {
    targetUrl: string,
    altText: string,
    imageURL?: string
}

export class Logo extends React.Component<LogoProps, {isReducedMotion: boolean}> {

  constructor(props: LogoProps) {
    super(props)
    this.state = {
      isReducedMotion: false
    }
  }

  componentDidMount() {
    const reducedMotionObj = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.setState({'isReducedMotion': reducedMotionObj && reducedMotionObj.matches});
  }

  render() {
    const styledLogo = (this.state.isReducedMotion && this.props.imageURL && isMoving(this.props.imageURL)) ?
      reduceMotion(this.props.imageURL) :
      this.props.imageURL;
    return (
      <a href={this.props.targetUrl} className="pv-nav-logo" id="pv-nav-logo">
        <div className="pv-brand-logo"
         style={styledLogo ? styleForCustomLogo(styledLogo) : {}}>
          {this.props.altText}
        </div>
      </a>
    )
  }
}
